// // import { Component, OnInit } from '@angular/core';

// // @Component({
// //   selector: 'app-contact',
// //   templateUrl: './contact.component.html',
// //   styleUrls: ['./contact.component.scss']
// // })
// // export class ContactComponent implements OnInit {

// //   constructor() { }

// //   ngOnInit(): void {
// //   }

// // }




// import { Component, OnInit } from '@angular/core';
// import {
//     FormBuilder,
//     FormGroup,
//     Validators
// } from '@angular/forms';

// @Component({
//     selector: 'app-contact',
//     templateUrl: './contact.component.html',
//     styleUrls: ['./contact.component.scss']
// })
// export class ContactComponent implements OnInit {

//     contactForm!: FormGroup;

//     submitted = false;

//     isSubmitting = false;

//     errorMessage = '';


//     constructor(
//         private fb: FormBuilder
//     ) {}


//     ngOnInit(): void {

//         this.contactForm =
//             this.fb.group({

//                 name: [
//                     '',
//                     Validators.required
//                 ],

//                 email: [
//                     '',
//                     [
//                         Validators.required,
//                         Validators.email
//                     ]
//                 ],

//                 phone: [
//                     ''
//                 ],

//                 role: [
//                     ''
//                 ],

//                 city: [
//                     ''
//                 ],

//                 message: [
//                     '',
//                     Validators.required
//                 ],

//                 smsOptIn: [
//                     false
//                 ]

//             });

//     }


//     submitForm(): void {

//         this.errorMessage = '';


//         // =========================================
//         // VALIDATE FORM
//         // =========================================

//         if (this.contactForm.invalid) {

//             this.contactForm.markAllAsTouched();

//             this.errorMessage =
//                 'Please complete the required fields.';

//             return;
//         }


//         // =========================================
//         // FORM DATA
//         // =========================================

//         const formValue =
//             this.contactForm.value;


//         console.log(
//             'Contact form submission:',
//             formValue
//         );


//         // =========================================
//         // IMPORTANT
//         // =========================================
//         //
//         // Connect your existing backend/API here.
//         //
//         // Do NOT put the client's Zapier webhook
//         // directly into the Angular frontend.
//         //
//         // Example:
//         //
//         // this.contactService.submitContact(formValue)
//         //     .subscribe({
//         //
//         //         next: () => {
//         //             this.submitted = true;
//         //             this.isSubmitting = false;
//         //         },
//         //
//         //         error: () => {
//         //             this.errorMessage =
//         //                 'Something went wrong. Please try again.';
//         //
//         //             this.isSubmitting = false;
//         //         }
//         //
//         //     });
//         //
//         // =========================================


//         this.isSubmitting = true;


//         /*
//          * TEMPORARY SUCCESS
//          *
//          * Replace this with your actual API call.
//          */

//         setTimeout(() => {

//             this.isSubmitting = false;

//             this.submitted = true;

//         }, 500);

//     }

// }


import { Component, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators
} from '@angular/forms';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

    contactForm!: FormGroup;

    submitted = false;

    isSubmitting = false;

    errorMessage = '';

    // =========================================
    // ZAPIER WEBHOOK
    // =========================================
    //
    // Paste the webhook URL copied from Zapier here.
    //
    private readonly zapierWebhookUrl =
        'https://hooks.zapier.com/hooks/catch/28635459/4tl28l2/';


    constructor(
        private fb: FormBuilder
    ) { }


    ngOnInit(): void {

        this.contactForm = this.fb.group({

            name: [
                '',
                Validators.required
            ],

            email: [
                '',
                [
                    Validators.required,
                    Validators.email
                ]
            ],

            phone: [
                ''
            ],

            role: [
                ''
            ],

            city: [
                ''
            ],

            message: [
                '',
                Validators.required
            ],

            smsOptIn: [
                false
            ]

        });

    }


    // =========================================
    // SUBMIT CONTACT FORM
    // =========================================

    submitForm(): void {

        this.errorMessage = '';

        if (this.contactForm.invalid) {

            this.contactForm.markAllAsTouched();

            this.errorMessage =
                'Please complete the required fields.';

            return;
        }

        if (this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;

        const formValue = this.contactForm.value;

        console.log(
            'Contact form submission:',
            formValue
        );

        const formData = new URLSearchParams();

        formData.append('name', formValue.name || '');
        formData.append('email', formValue.email || '');
        formData.append('phone', formValue.phone || '');
        formData.append('role', formValue.role || '');
        formData.append('city', formValue.city || '');
        formData.append('message', formValue.message || '');
        formData.append(
            'smsOptIn',
            formValue.smsOptIn ? 'Yes' : 'No'
        );

        fetch(
            this.zapierWebhookUrl,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(() => {

                console.log(
                    'Contact form submitted to Zapier'
                );

                this.isSubmitting = false;

                this.submitted = true;

                this.contactForm.reset({
                    name: '',
                    email: '',
                    phone: '',
                    role: '',
                    city: '',
                    message: '',
                    smsOptIn: false
                });

            })
            .catch((error) => {

                console.error(
                    'Zapier submission error:',
                    error
                );

                this.isSubmitting = false;

                this.errorMessage =
                    'Something went wrong while sending your message. Please try again or call 704.626.1776.';

            });

    }

}